import { useEffect, useState } from 'react'
import { FlutterDeviceRegistrationRequest } from '../../services/notifications/types';
import { useLocalStorage } from '../useLocalStorage';

export enum DevicePlatform {
    iOS,
    Android,
    unknown
}
// api
interface UseFlutterAppInterfaceOutput {
    //channel: any,
    isFlutterInAppWebViewReady: boolean,
    platform: DevicePlatform,
    platformString: string | undefined,
    deviceId: string | undefined,
    deviceRegistrationToken: string | undefined
    testFunction: any
}
function useFlutterAppInterface(onMessageReceived?: (methodCall: FlutterMethodCallRequest) => void): UseFlutterAppInterfaceOutput {
    const [port, setPort] = useState<any>();
    const [platform, setPlatform] = useState<DevicePlatform>(DevicePlatform.unknown);
    const [isFlutterInAppWebViewReady,setIsFlutterInAppWebViewReady] = useState<boolean>(false);
    const [deviceRegistrationToken,setDeviceRegistrationToken] = useLocalStorage("oqdo-deviceRegistrationToken","")
    const [deviceId,setDeviceId] = useLocalStorage("oqdo-deviceId","")
    const [platformString,setPlatformString] = useLocalStorage("oqdo-deviceplatform","")


    function test() {
        setIsFlutterInAppWebViewReady(true);
        setDeviceId("a");
        setDeviceRegistrationToken("b");
    }

    useEffect(() => {
        // or using a global flag variable
        window.addEventListener("flutterInAppWebViewPlatformReady", function (event) {
            console.debug("[useFlutterAppInterface] flutterInAppWebViewPlatformReady");
            setIsFlutterInAppWebViewReady(true);
        });

        window.addEventListener("message", function (event) {
            if (event.data === 'capturePort') {
                // capture port2 coming from the Dart side
                if (event.ports[0] != null) {
                    console.debug("[useFlutterAppInterface] flutter communication port captured");
                    // the port is ready for communication,
                    // so you can use port.postMessage(message); wherever you want
                    setPort(event.ports[0]);
                }
            }

        }, false);
    }, [])

    useEffect(() => {
        if (port) {
            // To listen to messages coming from the Dart side, set the onmessage event listener
            port.onmessage = function (event: any) {
                // event.data contains the message data coming from the Dart side
                console.debug("[useFlutterAppInterface].onMessageReceived", event.data);
                try {
                    const mc: FlutterMethodCallRequest = JSON.parse(event.data);
                    setPlatformString(mc.platform);
                    setPlatform(mc.platform === "TargetPlatform.iOS" ? DevicePlatform.iOS : mc.platform === "TargetPlatform.android" ? DevicePlatform.Android : DevicePlatform.unknown);
                    const req: FlutterDeviceRegistrationRequest = mc.data;
                    if (req !== null && req !== undefined) {
                        setDeviceId(req.deviceId);
                        setDeviceRegistrationToken(req.deviceRegistrationToken)
                    }
                    setIsFlutterInAppWebViewReady(true);
                    console.log("[useFlutterAppInterface].onMessageReceived - call onMessageRecived callback", mc);
                    if (onMessageReceived) onMessageReceived(mc);
                } catch (e) {
                    alert(e);
                    console.error(e);
                }
            };
        }
    }, [port, onMessageReceived]);

    return {
        isFlutterInAppWebViewReady: isFlutterInAppWebViewReady,
        platform: platform,
        deviceId: deviceId,
        deviceRegistrationToken: deviceRegistrationToken,
        platformString: platformString,
        testFunction: test
    }
}

export default useFlutterAppInterface

export interface FlutterMethodCallRequest {
    functionName: string,
    data: any,
    platform: string
}

